import { c as _c } from "react/compiler-runtime";
import { GRANT_DETAILS_SKELETON_FIELDS } from "../utils/constants";
export function GrantItemSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-h-14 tw-w-14 tw-rounded-lg tw-bg-iron-800" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-4"><div className="tw-flex tw-items-start tw-gap-3">{t0}<div className="tw-space-y-2"><div className="tw-h-4 tw-w-36 tw-rounded tw-bg-iron-800" /><div className="tw-h-3 tw-w-24 tw-rounded tw-bg-iron-800" /></div></div><div className="tw-h-5 tw-w-16 tw-rounded-full tw-bg-iron-800" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-animate-pulse tw-space-y-4">{t1}<div className="tw-grid tw-gap-3 sm:tw-grid-cols-2 lg:tw-grid-cols-3">{GRANT_DETAILS_SKELETON_FIELDS.map(_temp)}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(field) {
  return <div key={field} className="tw-space-y-2"><div className="tw-h-3 tw-w-20 tw-rounded tw-bg-iron-800" /><div className="tw-h-4 tw-w-24 tw-rounded tw-bg-iron-700" /></div>;
}